module.exports = __webpack_public_path__ + "static/media/2dbf90b9d744fb217181586cbeb4b80.0525ff54.jpg";